<template>
    <div class="page myPaperPage">
        <!--<h3 class="page-title">{{$t('paper.myPaper')}}</h3>-->

        <el-form class="page-query" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('paper.name')">
                <el-input v-model="formSearch.title" :placeholder="$t('tip.paperName')"
                          :class="{'big-input': $i18n.locale==='en'}"
                          @keyup.enter.native="queryPapers(1)"
                          clearable></el-input>
            </el-form-item>

            <select-multiple :nameArrays="selectNames"
                             @getForLevelVal="getForLevelVal"
                             @getPaperTypeVal="getPaperTypeVal"
                             @getDifficultyVal="getDifficultyVal"
                             @getPaperMethodVal="getPaperMethodVal"
            >
            </select-multiple>

            <select-multi-knowledge @knowledgeChange="knowledgeChange"></select-multi-knowledge>

            <el-form-item :label="$t('c.productionDate')">
                <el-date-picker
                    v-model="formSearch.afterDate"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{$t('c.to')}}</span>
                <el-date-picker
                    v-model="formSearch.beforeDate"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryPapers(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>
        <div class="page-table">
            <div class="page-operate">
                <a :href="href" ref="downLoad" id="export-a"></a>
                <el-button-group>

                    <el-button size="small" @click="$router.push({name: 'addTheoryPaper'})">
                        <i class="nucfont inuc-theory"></i> {{$t('paper.theoryPaperMake')}}
                    </el-button>

                    <el-button size="small" @click="$router.push({name: 'addImagePaper'})">
                        <i class="nucfont inuc-picture-add"></i> {{$t('paper.imagePaperMake')}}
                    </el-button>

                    <el-button size="small" @click="$router.push({name: 'addFiscanPaper'})">
                        <i class="nucfont inuc-picture-add"></i> 职鉴考卷制作
                    </el-button>
                </el-button-group>

                <el-tooltip v-show="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')" placement="top-end"
                            :hide-after="1000">
                    <el-button size="small" :title="$t('c.delete')" @click="deletePaper" style="margin-left: 10px;">
                        <i class="nucfont inuc-delete"></i>
                    </el-button>
                </el-tooltip>
            </div>
            <data-tables class="form-table"
                         ref="paperTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page.sync="currentPage"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                         @selection-change="handleSelectionChange"
            >
                <!-- column checkbox -->
                <el-table-column
                    type="selection"
                    width="55px"
                    :reserve-selection="true"
                    align="center">
                </el-table-column>
                <!-- column title -->
                <el-table-column property="title" :label="$t('paper.name')" align="center"
                                 min-width="190px" show-overflow-tooltip></el-table-column>
                <el-table-column property="typeName" :label="$t('paper.type')" align="center" width="105px" show-overflow-tooltip sortable>
                    <template #default="{row}">
                        <type-tag type="paperType" :id="row.type" :name="row.typeName"></type-tag>
                    </template>
                </el-table-column>
                <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.label"
                                 align="center"
                                 :width="title.width" :min-width="title.minWidth"
                                 show-overflow-tooltip
                                 :sortable="title.sortable">
                    <template v-if="title.prop==='methodName'" #default="{row}">
                        <i class="nucfont inuc-tupian" v-if="row.method === 5"></i>
                        {{row.methodName}}
                    </template>
                </el-table-column>

                <el-table-column v-if="userInfo.type===1" prop="creatorName" :label="$t('c.creator')" align="center" show-overflow-tooltip sortable></el-table-column>

                <!-- column buttons -->
                <el-table-column :label="$t('c.operation')" align="center">
                    <div class="btn-cell" slot-scope="scope">
                        <i
                            :title="$t('c.view')"
                            class="nucfont inuc-preview"
                            @click="previewPaper(scope.row)">
                        </i>
                        <i
                            :title="$t('c.edit')"
                            class="nucfont inuc-edit"
                            @click="editPaper(scope.row.id,scope.row.type)">
                        </i>
                        <i  v-if="scope.row.type==1 && scope.row.method!==5"
                            :title="$t('paper.exportPaper')"
                            class="nucfont inuc-word"
                            @click="exportPaper(scope.row.id)">
                        </i>
                    </div>
                </el-table-column>
            </data-tables>
        </div>
        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @needUpdate="queryPapers"></router-view>
        </transition>

        <!-- 图像全屏查看 -->
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
    import api from '@/api';
    import {screenfull, Ticket} from '@/utils';
    import {mapGetters} from 'vuex'
    import FullScreen from '@/components/FullScreen.vue';
    import selectMultiKnowledge from '@/components/SelectMultiKnowledge';
    import selectMultiple from '@/components/Selectmultiple.vue'

    export default {
        data(){
            return{
                isShow: false,
                src: null,
                formSearch:{
                    title:'',
                    types: [],
                    forLevels: [],
                    difficulties: [],
                    methods: [],
                    afterDate: '',
                    beforeDate: '',
                    knowledges:[0],
                },
                selectNames: [
                    {
                        key: "paperType",
                    }, {
                        key: "forLevel",
                    }, {
                        key: "difficulty",
                    }, {
                        key: "paperMethod",
                    }],
                isDeleteShow: false,
                tableData:[],
                tableProps: {
                    border: true,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "auto"
                },
                currentPage: 1,
                titles: [
                    {
                        prop: 'methodName',
                        label: this.$t('paper.paperMethod')
                    }, {
                        prop: 'formName',
                        label: this.$t('c.examType')
                    }, {
                        prop: 'forLevelName',
                        label: this.$t('c.operatorLevel')
                    }, {
                        prop: 'totalScore',
                        label: this.$t('paper.paperScore'),
                        sortable: 'custom'
                    }, {
                        prop: 'passScore',
                        label: this.$t('paper.passScore'),
                        sortable: 'custom'
                    },{
                        prop: 'knowledgeName',
                        label: this.$t('c.knowledgePoint')
                    }, {
                        prop: 'difficultyName',
                        label: this.$t('c.difficulty'),
                        sortable: 'custom'
                    },
                ],
                href: undefined,
            }
        },
        computed: {
            ...mapGetters(['userInfo',]),
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.beforeDate) return false;
                        return time.getTime() > new Date(that.formSearch.beforeDate).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.afterDate) return false;
                        return time.getTime() < new Date(that.formSearch.afterDate).getTime()
                    },
                }
            },
        },
        created() {
            this.queryPapers();
        },
        methods:{
            queryPapers(type){
                if(type==1){
                    this.currentPage = 1;
                }

                let queryData = {...this.formSearch};
                // 全选不传值
                ['types', 'forLevels', 'difficulties', 'methods', 'knowledges'].forEach(v => {
                    if (this.formSearch[v].includes(0)) {
                        delete queryData[v];
                    }
                });

                this.$nextTick(() => {
                    api.getMyPaper(queryData).then(res => {
                        for (let i = 0; i < res.package.length; i++) {
                            res.package[i].createTime ? res.package[i].createTime = res.package[i].createTime.replace("T", " ") : res.package[i].createTime = "—";
                        }
                        this.tableData = res.package;
                    })
                })

            },

            editPaper(id,type){
                let names = {
                    1: 'editTheoryPaper',
                    3: 'editImagePaper',
                    4: 'editImagePaper',
                    5: 'editFiscanPaper',
                }

                this.$router.push({name: names[type], params: {paperId: id,paperType:type}})
            },

            previewPaper({id, type}) {
                switch (type) {
                    case 1:
                        this.$router.push({name: 'paperPreview',params: {paperId: id}});
                        screenfull.request();
                        break;
                    case 3:
                        this.isShow = !this.isShow
                        this.src = `${api.imagePanoramicHost}/ctPaperDetail?paperId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=PAPER_PREVIEW&paperID=${id}`
                        this.$refs.nstswrap.fullScreen()
                        break
                    case 4:
                        this.isShow = !this.isShow
                        this.src = `${api.imagePanoramicHost}/drPaperDetail?paperId=${id}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=PAPER_PREVIEW&paperID=${id}`
                        this.$refs.nstswrap.fullScreen()
                        break
                    case 5:
                        // todo: 查看职鉴考卷
                        this.$router.push({name: 'paperPreview',params: {paperId: id}, query: {isFiscan: true}});
                        screenfull.request();
                        break
                    default:
                        break
                }
            },
            // 图像考卷预览
            toggleIsShow (val) {
                this.isShow = val;
                this.src = null
            },
            //导出考卷
            exportPaper(id){
                const ticket = Ticket.get().access_token;
                const culture = this.$i18n.locale;
                this.href = `${APIURI}/api/Export/word/paper/theory/${id}?access_token=${ticket}&culture=${culture}&ui-culture=${culture}`;
                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },
            //考卷删除
            deletePaper() {
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    type: 'warning'
                }).then(() => {
                    if (this.selectIds.length === 1) {
                        return api.deleteMyPaper(this.selectIds);
                    } else {
                        return api.deleteMyPapers({ids: this.selectIds});
                    }
                }).then(() => {
                    this.success(this.$t('m.delSuccess'));
                    this.isDeleteShow = false;
                    this.queryPapers();
                    this.$refs.paperTable.$refs.elTable.clearSelection();
                }).catch(()=>{});
            },
            handleSelectionChange(val) {
                this.selectIds = [];
                val.forEach(v => this.selectIds.push(v.id));
                this.isDeleteShow = this.selectIds.length > 0;
            },

            //搜索赋值
            getPaperTypeVal(data){
                this.formSearch.types = data;
            },
            getForLevelVal(data){
                this.formSearch.forLevels = data;
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data;
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data;
            },
            getPaperMethodVal(data) {
                this.formSearch.methods = data;
            },

            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
        components: {
            selectMultiple,
            selectMultiKnowledge,
            FullScreen
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .big-input {
        width: 205px;
    }

    .page-operate {
        display: flex;
        align-items: center;

        button {
            width: auto;
        }
        .nucfont {
            margin-right: 3px;
            font-size: 14px;
        }
    }
</style>


